module.exports = __webpack_public_path__ + "img/card.aa7e3751.png";